import {
  Directive,
  ElementRef,
  EventEmitter,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { GoogleMapsLoaderService } from '@web-frontend/shared/services/google-maps-loader.service';

@Directive({
  selector: '[romaGooglePlaces]',
})
export class GooglePlacesDirective implements OnInit, OnDestroy {
  @Output() placeSelected = new EventEmitter<any>();

  private autocomplete!: google.maps.places.Autocomplete;
  private placeChangedListener?: google.maps.MapsEventListener;
  private destroyed = false;

  constructor(
    private el: ElementRef,
    private ngZone: NgZone,
    private googleMapsLoader: GoogleMapsLoaderService
  ) {}

  ngOnInit(): void {
    this.googleMapsLoader
      .load()
      .then(() => {
        if (this.destroyed) return;

        this.autocomplete = new google.maps.places.Autocomplete(
          this.el.nativeElement,
          {
            types: ['geocode', 'establishment'],
          }
        );

        this.placeChangedListener = this.autocomplete.addListener(
          'place_changed',
          () => {
            this.ngZone.run(() => {
              const place = this.autocomplete.getPlace();
              if (place.geometry) {
                this.placeSelected.emit(place);
              }
            });
          }
        );
      })
      .catch((error) => {
        console.error('Failed to load Google Maps Places autocomplete.', error);
      });
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    this.placeChangedListener?.remove();
  }
}
